import { FruitPineappleIcon } from './FruitPineappleIcon';

/**
 * author: Michael Irigoyen
 * id F28FDEF7-E169-45AA-84E7-13DB0A6CA241
 * name fruit-pineapple
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fruit-pineapple.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const FruitAnanasIcon = FruitPineappleIcon;
export default FruitAnanasIcon